module.exports = __webpack_public_path__ + "static/media/new.4a79b660.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/new.png
// module id = 1505
// module chunks = 0